import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  formatMoney,
} from '@populateui/utils';
import {
  VisitNoteServiceCode,
} from 'views/EMR/components/ServiceLookup/type';

export default {
  id: 'billedAmount',
  cell: ({ row }) => formatMoney(
    row?.original?.defaultBilledAmountPerUnit ?? 0,
  ),
  className: '!items-center font-semibold',
  columnTitle: 'Price Per Unit',
  size: 150,
} as ColumnDef<VisitNoteServiceCode>;
